
import React from "react";

interface DividerProps {
  isCollapsed: boolean;
  title?: string;
}

export const SidebarDivider: React.FC<DividerProps> = ({ isCollapsed, title }) => {
  return (
    <div className="px-3 mb-2">
      <div className={`h-px w-full bg-gradient-to-r from-transparent via-[#2A3749] to-transparent ${isCollapsed ? 'opacity-30' : ''}`}></div>
      {!isCollapsed && title && (
        <h3 className="text-xs uppercase text-gray-500 px-3 py-2">{title}</h3>
      )}
    </div>
  );
};
